<template>
    <div class="layout-container-box">
      <el-header class="layout-header">
        <Header>
          <template #header-brand>
            <BreadCrumb :breadList="breadList" />
          </template>
        </Header>
      </el-header>
      <el-scrollbar class="layout-main-content" id="content_box">
        <div class="pd-20">
          <div class="list-container">

            <SearchFilterBar
              :statusLabels="publishStatus"
              :addShow="true"
              :pubStatus="0"
              @typeChange="statusChange"
              @statusChange="pubstatusChange"
              @searchClick="handleSearch"
              @clearSearchInput="clearSearchInput"
              @addClick="handleClick"
              :selectShow="true"
              :selectOptions="selectOptions"
              selectLable="活动状态"
              :statusFlag="true"
              :publishStatus="publishStatus"
            />

            <div class="table-con mg-t-12">
              <el-scrollbar>
                <div class="pd-32" style="background: #fff">
                  <el-table :data="ListData" border>
                    <el-table-column
                      prop="id"
                      width="70"
                      align="center"
                      label="活动ID"
                    />
                    <el-table-column
                      name="title"
                      prop="title"
                      label="活动名称"
                      show-overflow-tooltip
                      width="300"
                    />
                    <el-table-column
                      prop="report_type"
                      width="120"
                      align="center"
                      show-overflow-tooltip
                      label="活动地点"
                    >
                        <template #default="scope">
                            <div v-if="scope.row.activity_mode==1">线上</div>
                            <div v-if="scope.row.activity_mode==2">{{ scope.row.activity_address_city }} {{ scope.row.activity_address }}</div>
                        </template>
                    </el-table-column>

                    <el-table-column
                      prop="activity_time"
                      width="120"
                      align="center"
                      label="活动时间"
                      show-overflow-tooltip
                    >
                    <template #default="scope">
                      <div>{{ scope.row.activity_time.split(",")[0] }}</div>
                      <div>{{ scope.row.activity_time.split(",")[1] }}</div>
                    </template>
                    </el-table-column>
                    <el-table-column
                      prop="publish_time"
                      width="160"
                      align="center"
                      label="发布时间"
                      show-overflow-tooltip
                    />
                    
                    <el-table-column
                      prop="creator"
                      width="120"
                      align="center"
                      label="活动状态"
                    >
                        <template #default="scope">
                            <div>
                                {{ scope.row.status==1?'待开始':scope.row.status==2?'报名中':scope.row.status==3?'进行中':'已结束' }}
                                <!-- <el-select v-model="scope.row.status" placeholder="please select your zone" @change="handelStatus(scope.row.status,scope.row.id)">
                                  <el-option label="待开始" value="1" />
                                  <el-option label="报名中" value="2" />
                                  <el-option label="进行中" value="3" />
                                  <el-option label="已结束" value="4" />
                                </el-select> -->
                            </div>
                        </template>
                    </el-table-column>


                    <el-table-column
                      prop="label_names"
                      width="70"
                      show-overflow-tooltip
                      align="center"
                      label="收费金额"
                    >
                        <template #default="scope">
                            <div>
                                {{ scope.row.money!=''?scope.row.money:'免费' }}
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column
                      prop="create_time"
                      width="70"
                      align="center"
                      label="是否需要审核"
                    >
                        <template #default="scope">
                            <div>
                                {{ scope.row.is_check==1?'不需要':'需要' }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                      prop="create_time"
                      width="180"
                      align="center"
                      label="报名人数（待审核/审核通过/总数）"
                      >
                        <template #default="scope">
                            <div>
                                {{ scope.row.no_check_num }}/{{ scope.row.is_check_num }}/{{ scope.row.register_num }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                      prop="sort"
                      width="100"
                      align="center"
                      label="排序（越大越前）"
                    >
                    <template v-slot="{ row }">
                        <el-input
                            :min="0"
                            v-model="row.sort"
                            @change="setSort(row)"
                            type="number"
                        ></el-input>
                        </template>
                    </el-table-column>

                    <el-table-column
                      prop="publish_status"
                      width="90"
                      align="center"
                      label="上架状态"
                    >
                      <template #default="scope">
                        <span
                          class="status-text primary"
                          v-if="scope.row.publish_status === 2"
                          >已上架</span
                        >
                        <span class="status-text info" v-else>未上架</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="operator_name"
                      width="180"
                      align="center"
                      label="最近操作人"
                    />
                    <el-table-column
                      label="操作"
                      width="150"
                      align="center"
                      fixed="right"
                    >
                      <template #default="scope">
                        <el-link
                          class="mg-r-12"
                          type="primary"
                          @click="handleDetail(scope.row.id)"
                          >报名详情</el-link
                        >
                        <el-link
                          class="mg-r-12"
                          type="primary"
                          v-if="scope.row.publish_status !== 2"
                          @click="handleClick(scope.row.id)"
                          >编辑</el-link
                        >
                        <el-link
                          v-if="scope.row.publish_status === 2"
                          class="mg-r-12"
                          type="primary"
                          @click="
                            changeStatus(scope.row.id, scope.row.publish_status)
                          "
                          >下架</el-link
                        >
                        <el-link
                          v-else
                          class="mg-r-12"
                          type="primary"
                          @click="
                            changeStatus(scope.row.id, scope.row.publish_status)
                          "
                          >上架</el-link
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="table-pagination-row mg-t-24">
                    <el-pagination
                      v-show="paginationData.total > paginationData.size"
                      :background="background"
                      v-model:current-page.sync="paginationData.current"
                      v-model:page-size.sync="paginationData.size"
                      :layout="layout"
                      :total="paginationData.total"
                      v-bind="$attrs"
                      @current-change="handleCurrentChange"
                      @pagination="getTableData"
                    />
                  </div>
                </div>
              </el-scrollbar>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </template>
  
  <script>
  import { reactive, onMounted, ref } from "vue";
  import { useRouter } from "vue-router";
  import { ElMessageBox } from "element-plus";
  import SearchFilterBar from "@/components/SearchFilterBar/index.vue";
  import { Ajax, MessageTips } from "@/utils";
  import Header from "@/Layout/components/Header.vue";
  import BreadCrumb from "@/components/BreadCrumb/index.vue";
  
  export default {
    components: {
      Header,
      BreadCrumb,
      SearchFilterBar,
    },
    setup() {
      const router = useRouter();
  
      const state = reactive({
        breadList: [
          {
            name: "活动列表",
          },
        ],
        typeLabels: [
          // {
          //   value: 1,
          //   name: "待开始",
          // },
          {
            value: 2,
            name: "报名中",
          },
          {
            value: 3,
            name: "进行中",
          },
          {
            value: 4,
            name: "已结束",
          }
        ],
        publishStatus: [
        {
            value: 0,
            name: "全部",
          },
          {
            value: 1,
            name: "未上架",
          },
          {
            value: 2,
            name: "已上架",
          },
          
        ],
        queryData: {
          size: 10,
          page: 1,
          status: 0,
          publish: 0,
          title: "",
        },
        mainTableKey: 1,
      });
      const selectOptions = ref([
        // {label:"待开始",value:1},
        {label:"报名中",value:2},
        {label:"进行中",value:3},
        {label:"已结束",value:4}
      ])
      const ListData = ref([]);
      const paginationData = ref({
        current: 1,
        size: state.queryData.size,
        total: 0,
      });
      // 状态选择
      const statusChange = (status) => {
        state.queryData.status = status;
        state.queryData.page = 1;
        paginationData.value.current = 1;
        getTableData();
      };
  
      const pubstatusChange = (status) => {
        state.queryData.publish = status;
        state.queryData.page = 1;
        paginationData.value.current = 1;
        getTableData();
      };
  
      // 查询
      const handleSearch = ({ searchValue }) => {
        state.queryData.title = searchValue;
        getTableData();
      };
      const clearSearchInput= ()=>{
        state.queryData.title = ''
      }
  
      const getTableData = async () => {
        const ret = await Ajax.POST({
          url: "/admin/activity/list",
          data: state.queryData,
        });
        if (ret.data.code === 200) {
          ret.data.data.items.forEach(item=>{
            item.status = item.status.toString()
          })
          ListData.value = ret.data.data.items;
          paginationData.value.total = ret.data.data.total;
        } else {
          MessageTips.error(ret.data.msg);
        }
      };
  
      const setStatus = async (id, status) => {
        const ret = await Ajax.POST({
          url: "/admin/activity/publish/" + id,
          data: { publish: status },
        });
        if (ret.data.code === 200) {
          getTableData();
        } else {
          MessageTips.error(ret.data.msg);
        }
      };
  
      const changeStatus = async (id, status) => {
        let str = status == 2 ? "下架" : "上架";
        ElMessageBox.confirm("确认" + str + "该活动?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            setStatus(id, status === 2 ? 1 : 2);
          })
          .catch(() => {
            MessageTips.info("已取消" + str);
          });
      };
      const handelStatus =async (statue,id)=>{
        // console.log(statue,id)
        const ret = await Ajax.POST({
          url: "/admin/activity/status/" + id,
          data: { status: statue },
        });
        if(ret.data.code === 200){
          getTableData();
          MessageTips.success("修改成功");
        } else {
          MessageTips.error(ret.data.msg);
        }
      }
      const handleCurrentChange = (val) => {
        state.queryData.page = val;
        paginationData.value.current = val;
        getTableData();
      };
  
      const handleSizeChange = () => {};
  
      // 详情
      const handleDetail = (item) => {
        router.push({
          name: "ActivityDetail",
          // params: { id: item },
          query: { id: item }
        });
      };
  
      const handleClick = (id) => {
        // console.log('id', id, typeof id === 'object')
        if (typeof id === "object") {
          router.push({
            name: "ActivityCreate",
          });
        } else {
          // debugger
          router.push({
            name: "ActivityCreate",
            path:"/activity/create",
            // params: { id:id },
            query: { id: id }
          });
        }
      };
      /**
         * 排序
         */
        const setSort = async (row) => {
            const ret = await Ajax.POST({
                url: "/admin/activity/sort/"+row.id,
                data: {sort:row.sort},
                });
                if (ret.data.code === 200) {
                    MessageTips.success("保存成功");
                    getTableData();
                } else {
                MessageTips.error(ret.data.msg);
                }
        };
  
      onMounted(() => {
        getTableData();
      });
  
      return {
        ...state,
        statusChange,
        pubstatusChange,
        handleSearch,
        changeStatus,
        handleCurrentChange,
        handleSizeChange,
        getTableData,
        ListData,
        paginationData,
        handleDetail,
        handleClick,
        selectOptions,
        setSort,
        handelStatus,
        clearSearchInput
      };
    },
    methods: {
      setgender(row, colum) {
        return row.report_type === 1 ? "简报" : "深度";
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .list-container {
    height: 100%;
    .status-text {
      font-size: 14px;
      &.primary {
        color: #409eff;
      }
      &.info {
        color: #909399;
      }
    }
    .table-pagination-row {
      display: flex;
      justify-content: flex-end;
    }
  }
  </style>
  